import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import moment from "moment"
import * as orderApi from "../../utilities/apis/order_history"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"

const OrderHistory = () => {
  const { token } = useSelector(state => state.user)
  const [orderHistories, setOrderHistories] = useState([])
  const mobileRef = useRef(null)
  const [active, setActive] = useState(1)
  const [count, setCount] = useState(0)
  const [filters, setFilters] = useState({
    limit: 10,
    offset: 0,
  })

  const handleSearch = () => {
    const where = {}

    if (mobileRef.current.value) where.customer = mobileRef.current.value

    setFilters({ ...filters, offset: 0, ...where })
    setActive(1)
  }

  const handleReset = () => {
    setFilters({ limit: 10, offset: 0 })
    mobileRef.current.value = ''
    setActive(1)
  }

  const getOrderHistories = async () => {
    try {
      const query = new URLSearchParams(filters)
      const response = await orderApi.getOrderHistories(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setCount(response.count)
      setOrderHistories(response.order_histories)
    } catch (error) {
      alert(error.message)
    }
  }

  const handlePageChange = (page, offset) => {
    setFilters({ ...filters, offset })
    setActive(page)
  }

  useEffect(() => {
    getOrderHistories()
  }, [])

  useEffect(() => {
    getOrderHistories(filters)
  }, [filters])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-75 mx-auto">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="lead text-body-emphasis fw-bold m-0">Order History</p>
          </div>

          <div className="border rounded-4 mb-3">
            <div className="p-3 border-bottom rounded-top-4 bg-secondary">
              <div className="row">
                <div className="col-md-2">
                  <input ref={mobileRef} type="text" className="form-control form-control-sm rounded-3" id="mobile" placeholder="Mobile #" required autoFocus />
                </div>
                <div className="col-md-8" />
                <div className="col-md-2">
                  <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-sm btn-light-theme rounded-3" onClick={handleSearch}><i className="fas fa-search me-2"></i> Search</button>
                    <button type="reset" className="btn btn-sm btn-light-danger rounded-3" onClick={handleReset}><i className="fas fa-times me-2"></i> Clear</button>
                  </div>
                </div>
              </div>
            </div>
            <table className="table table-hover shadow-none m-0">
              <thead className="table-light">
                <tr>
                  <th scope="col" style={{ width: "10%" }} className="align-middle text-center">S. No.</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle">Customer</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle">Product</th>
                  <th scope="col" style={{ width: "15%" }} className="align-middle">Quantity</th>
                  <th scope="col" style={{ width: "25%" }} className="align-middle">Last Order</th>
                </tr>
              </thead>
              <tbody>
                {orderHistories.map((row) => {
                  return (
                    <tr key={row.id.toString()}>
                      <td className="align-middle text-center">{row.id}</td>
                      <td className="align-middle">{row.customer.mobile}</td>
                      <td className="align-middle">{row.product.title}</td>
                      <td className="align-middle">{row.quantity}</td>
                      <td className="align-middle">{row.last_order && moment(row.last_order).format("DD-MM-YYYY")}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          <nav aria-label="pagination">
            <Pagination
              currentPage={active}
              totalCount={count}
              pageSize={filters.limit}
              offset={filters.offset}
              siblingCount={3}
              onPageChange={handlePageChange}
            />
          </nav>
        </div>
      </main>
    </Layout>
  )
}

export default OrderHistory
